//React
import React from 'react';
//Add
import { imageResize, imageRotate } from '../func/imageResizeRotate';
import { withAlert } from 'react-alert';
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as myPhotoAction from '../action/myPhotoAction';
import * as uiAction from '../action/uiAction';
import * as helpAction from '../action/helpAction';

//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Fab from '@material-ui/core/Fab';
import Slide from '@material-ui/core/Slide';
//Icon
import ClearIcon from '@material-ui/icons/Clear';
import CloseIcon from '@material-ui/icons/Close';
import { BsPersonSquare } from 'react-icons/bs';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CropIcon from '@material-ui/icons/Crop';
//Part
import PartDropZone from './PartDropZone';
import PartInputInfoBalloon from './PartInputInfoBalloon';
//Dialog
import DialogImageCrop from './DialogImageCrop';

import NoPhotoUserMailConfuse from '../img/help/help_noPhotoUser_mail_confused.png';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      originImage: null,
      uploadThumb: null,
      uploadSecret: false,
      uploadSubmitVisible: false,
      uploadProgress: null,
      restriction: 1,
      dialogImageCropVisible: false,
  	}
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.originImage !== this.state.originImage && this.state.originImage) {
      this._imageLoad(this.state.originImage);
    }
  }

  async _imageLoad(file) {
    await imageResize(file, 1200).then((res) => {
      this.setState({uploadThumb:res.uri});
    }).catch((err) => {
      this.setState({uploadThumb:''});
      this.props.snackOpen('error', err.comment , 5000)
    })
  }

  async _imageRotate(rotate) {
    let file = this.state.uploadThumb;
    await imageRotate(file, rotate)
    .then((res) => {
      this.setState({uploadThumb:res.uri});
    })
  }

  _submit() {
    let imageBase64 = this.state.uploadThumb;
    let restriction = this.state.restriction;
    this.props.myPhotoMainAdd(imageBase64, restriction, () => {
      this.setState({uploadThumb:null});
      this.props.close();
    })
  }


	render() {

    if (this.props.my.proof.photo === 1) {
      return (
  			<Dialog
          open={this.props.open}
          onClose={ () => this.props.close() }
        >
          <>
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
                justifyContent:'space-between',
              }}
            >
              <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
                メイン写真の登録
              </div>

              <IconButton
                onClick={ () => this.props.close() }
              >
                <CloseIcon/>
              </IconButton>
            </div>
            <div style={{padding:'10px'}}>

              <div style={{margin:'5px'}}>
                <div>写真証明が提出済の為、メイン写真を申請できませんでした。</div>
                <div>写真証明を削除してから、メイン写真を申請してください。</div>
              </div>
              <div style={{margin:'5px'}}>
                <Button
                  variant="outlined"
                  color="primary"
                  size='small'
                  onClick={ () => this.props.history.push('/my/proof/') }
                >
                  写真証明の削除はコチラから
                </Button>
              </div>
            </div>
          </>
        </Dialog>
      )
    }
    else {
  		return (
  			<Dialog
          fullScreen
          open={this.props.open}
          onClose={ () => this.props.close() }
          TransitionComponent={Transition}
          style={{maxWidth:'600px', margin:'auto'}}
        >
          <div style={{position:'fixed',top:'0',left:'0px',width:'100%' ,zIndex:'101'}}>
            <div style={{maxWidth:'600px', margin:'auto', background:'#FFF'}} className='shadow'>
              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  justifyContent:'space-between',
                }}
              >
                <div>
                  <IconButton
                    onClick={ () => {
                      this.props.close();
                      this.setState({uploadThumb: null});
                    }}
                  >
                    <ArrowBackIosIcon />
                  </IconButton>
                  <span style={{fontSize:'1.1em',fontWeight:'bold'}}>メイン写真を掲載しませんか？</span>
                </div>
              </div>
            </div>
          </div>


          <div style={{padding:'60px 15px 15px 15px',}}>
            <div>
              {
                (this.state.uploadThumb) ?
                (
                  <div>

                    <div style={{textAlign:'center', margin:'5px', position:'relative', minHeight:'50px'}}>
                      <div align='center' style={{padding:'5px', position:'relative'}}>
                          <img style={{ width:'160px', height:'160px', objectFit:'contain' }} src={this.state.uploadThumb} id='thumb' alt='' />
                      </div>
                      <IconButton
                        style={{position:'absolute', right:'0px', top:'0px'}}
                        onClick={ () => this.setState({originImage:null, uploadThumb:null}) }
                      >
                        <ClearIcon/>
                      </IconButton>
                    </div>


                    <div align='center'>
                      <Fab
                        color='inherit'
                        size='small'
                        onClick={ () => this._imageRotate('l')}
                      >
                        <RotateLeftIcon/>
                      </Fab>
                      &nbsp;
                      <Fab
                        color='inherit'
                        size='small'
                        onClick={ () => this._imageRotate('r')}
                      >
                        <RotateRightIcon/>
                      </Fab>
                      &nbsp;
                      <Fab
                        color='inherit'
                        size='small'
                        onClick={ () => this.setState({dialogImageCropVisible: true}) }
                      >
                        <CropIcon/>
                      </Fab>
                    </div>

                    <DialogImageCrop
                      originImage={this.state.originImage}
                      open={this.state.dialogImageCropVisible}
                      close={ () => this.setState({dialogImageCropVisible: false}) }
                      onSubmit={ (img) => this.setState({uploadThumb:img}) }
                    />

                    <div align='center' style={{padding:'10px'}}>
                      <Select
                        value={this.state.restriction}
                        onChange={ (e) => this.setState({restriction: e.target.value}) }
                      >
                        <MenuItem value={ 0 }>公開制限しない</MenuItem>
                        <MenuItem value={ 1 }>公開制限する</MenuItem>
                      </Select>
                    </div>

                    <div align='center' >
                      <PartInputInfoBalloon>
                        {
                          (this.state.restriction) ? (
                            <div>メイン写真を掲載中の会員にだけ公開する設定です</div>
                          ): (
                            <div>すべての会員に公開する設定です</div>
                          )
                        }
                      </PartInputInfoBalloon>
                    </div>

                    <div align='center' style={{padding:'10px'}}>

                      <Button
                        variant="contained"
                        color="secondary"
                        style={{minWidth:'160px'}}
                        onClick={ () => this._submit() }
                        startIcon={<CloudUploadIcon />}
                      >
                        <span style={{fontSize:'1.4em'}}>アップロード</span>
                      </Button>
                    </div>
                  </div>
                ):
                (
                  <>
                    <div align='center'>
                      <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
                        メイン写真が未掲載の為<br />
                        返信をもらいにくい状態です
                      </div>
                      <img
                        style={{ width:'200px', height:'200px', borderRadius:'100px', objectFit:'contain', overflow:'hidden' }}
                        src={NoPhotoUserMailConfuse}
                        alt=''
                      />
                    </div>

                    <div style={{margin:'10px'}}>
                      どんな人かイメージできない方からのメールは不安を感じ、返信率が大きく下がります。<br />
                      お相手がメールを読まれる前にメイン写真を掲載しましょう。
                    </div>

                    <PartDropZone
                      handleDrop={ (v) => this.setState({originImage:v}) }
                      style={{position:'relative'}}
                    >
                      <div>
                        <div align='center' style={{padding:'10px'}}>
                          <label htmlFor="photo_file" style={{display:'block'}}>
                            <IconButton component="span">
                              <BsPersonSquare style={{fontSize:'4em'}}/>
                            </IconButton>
                          </label>

                          <label htmlFor="photo_file" style={{cursor:"pointer", display:'block'}}>
                            <Button variant="contained" color='primary' component="span">
                              <div>
                                <span style={{fontSize:'1.2em'}}>ファイルを選択する</span>

                              </div>
                            </Button>
                          </label>
                        </div>
                      </div>
                    </PartDropZone>
                  </>
                )
              }
              <input
                type='file'
                id='photo_file'
                accept='image/*'
                onChange={ (e) => {
                  this.setState({originImage:e.target.files[0]});
                  e.target.value = null;
                }}
                style={{opacity:'0'}}
              />
              <div>
                <div style={{color:'#666'}}>※不承認となった場合、サブ写真として掲載されます。</div>
              </div>
            </div>
          </div>
  			</Dialog>
  		)
    }
	}
}

const mapStateToProps = (state) => {
	return {
		my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...myPhotoAction,
    ...uiAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withAlert()(Comp));
